import React from "react";
import "../css/LegalPages.css";

const CookiePolicy = () => {
  return (
    <div className="legal-container">
      <h1>Çerez Politikası</h1>

      <section>
        <h3>1. Çerez Nedir?</h3>
        <p>
          Çerezler, ziyaret ettiğiniz internet siteleri tarafından cihazınıza
          kaydedilen küçük metin dosyalarıdır. Bu dosyalar; site deneyiminizi
          kişiselleştirmek, performansı artırmak ve hizmetlerimizi iyileştirmek
          amacıyla kullanılmaktadır.
        </p>
      </section>

      <section>
        <h3>2. Kullanılan Çerez Türleri</h3>
        <p>
          Halısahacım tarafından kullanılan çerez türleri aşağıdaki gibidir:
        </p>

        <ul>
          <li>
            <strong>Zorunlu Çerezler:</strong> Platformun çalışması için gerekli
            olan çerezlerdir. Üyelik işlemleri, güvenlik kontrolleri ve oturum
            yönetimi için kullanılmaktadır.
          </li>
          <li>
            <strong>Performans ve Analitik Çerezleri:</strong> Kullanıcı
            davranışlarını analiz ederek site trafiğini ölçer. Google Analytics
            gibi üçüncü taraf araçlarla anonim veriler toplanabilir.
          </li>
          <li>
            <strong>Fonksiyonel Çerezler:</strong> Tercihlerinizi (şehir seçimi,
            dil ayarı vb.) hatırlayarak daha kişisel bir deneyim sunar.
          </li>
          <li>
            <strong>Reklam / Hedefleme Çerezleri:</strong> Kullanıcı
            ilgi alanlarına göre özelleştirilmiş reklam gösterimleri için
            kullanılabilir. Üçüncü taraf reklam sağlayıcıları ile paylaşılabilir.
          </li>
        </ul>
      </section>

      <section>
        <h3>3. Çerezleri Ne İçin Kullanıyoruz?</h3>
        <ul>
          <li>Platform performansını artırmak</li>
          <li>Hata ve sorunları tespit etmek</li>
          <li>Rezervasyon deneyimini geliştirmek</li>
          <li>Üyelik işlemlerini kolaylaştırmak</li>
          <li>Tercihlerinizi hatırlamak</li>
        </ul>
      </section>

      <section>
        <h3>4. Çerezleri Yönetme ve Silme</h3>
        <p>
          Çoğu tarayıcı çerez kullanımını kısıtlama, engelleme veya silme
          seçenekleri sunar. Çerezleri devre dışı bırakmanız durumunda
          platformun bazı bölümleri düzgün çalışmayabilir.
        </p>
      </section>

      <section>
        <h3>5. Açık Rıza Gerektiren Çerezler</h3>
        <p>
          Zorunlu çerezler dışındaki tüm çerez türleri için kullanıcıdan açık
          rıza alınmaktadır. Kullanıcı çerez tercihlerini dilediği zaman
          değiştirebilir.
        </p>
      </section>

      <section>
        <h3>6. Saklama Süresi</h3>
        <p>
          Çerez tercihleri, ilgili mevzuata uygun şekilde <strong>6 ay</strong>
           süreyle saklanır. Süre sonunda kullanıcıdan tekrar izin istenir.
        </p>
      </section>

      <section>
        <h3>7. İletişim</h3>
        <p>
          Çerez politikamızla ilgili sorularınız için:{" "}
          <a href="mailto:halisahacim.com@gmail.com">
            halisahacim.com@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;
